import { MenuList, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import ROUTE from '../../../utils/router'
import { Link as RouterLink, useLocation } from 'react-router-dom'

const MenuBox = ({ isMobile, onNavigate }) => {
    const { pathname } = useLocation()
    const mainRoutes = ROUTE.find(route => route.componentName === 'PublicLayout')
    const childrenRouters = mainRoutes.children.filter(route => route.menu && (isMobile || !route.onlyMobile))
    
    const handleNavigate = (to) => {
        if (pathname === to && onNavigate) {
            onNavigate()
        }
    }

    return (
        <>
            <MenuList
                sx={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                    gap: 1,
                    p: isMobile ? 2 : 0,
                }}
            >
                {childrenRouters.map(route => {
                    const to = route.index ? mainRoutes.path : `/${route.path}`

                    return (
                        <MenuItem
                            key={`main_menu_${route.path}`}
                            component={RouterLink}
                            to={to}
                            onClick={() => handleNavigate(to)}
                            sx={{
                                borderRadius: 1,
                                width: '100%',
                                backgroundColor: pathname === to ? 'primary.main' : 'transparent',
                                color: pathname === to ? 'primary.contrastText' : 'text.primary',
                                '&:hover': {
                                    backgroundColor: pathname === to ? 'primary.dark' : 'action.hover',
                                },
                            }}
                        >
                            {route.icon && (
                                <ListItemIcon sx={{ color: pathname === to ? 'primary.contrastText' : 'text.primary' }}>
                                    {route.icon}
                                </ListItemIcon>
                            )}
                            <ListItemText primary={route.title} />
                        </MenuItem>

                    )
                })}
            </MenuList>
        </>
    );
};

export default MenuBox;

